import { render, staticRenderFns } from "./vehicleInsurance.vue?vue&type=template&id=52012d7c&scoped=true&"
import script from "./vehicleInsurance.vue?vue&type=script&lang=js&"
export * from "./vehicleInsurance.vue?vue&type=script&lang=js&"
import style0 from "./vehicleInsurance.vue?vue&type=style&index=0&id=52012d7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52012d7c",
  null
  
)

export default component.exports